import { render, staticRenderFns } from "./DispositionHistoryModal.vue?vue&type=template&id=2fb5fcc0&"
import script from "./DispositionHistoryModal.vue?vue&type=script&lang=js&"
export * from "./DispositionHistoryModal.vue?vue&type=script&lang=js&"
import style0 from "./DispositionHistoryModal.vue?vue&type=style&index=0&id=2fb5fcc0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports